import {AxiosError} from 'axios';
import {GET_BLACKLIST_CANDIDATE_TEMPLATE} from '../../constants/apiUrls';
import axiosClient from '../axiosClient';
import {useCustomQuery} from '../utils/useCustomQuery';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================

interface GetDownloadCandidateBlacklistTemplateResponse {
  url: string
}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: (data: GetDownloadCandidateBlacklistTemplateResponse) => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const useGetBlacklistCandidateTemplate = ({onSuccess, onError}: Input = {}) => {
  const getCandidateBlacklistTemplate = async () => {
    const res = await axiosClient.get<GetDownloadCandidateBlacklistTemplateResponse>(
        GET_BLACKLIST_CANDIDATE_TEMPLATE
    );

    return res.data;
  };

  return useCustomQuery(
      [GET_BLACKLIST_CANDIDATE_TEMPLATE],
      getCandidateBlacklistTemplate,
      {
        onSuccess,
        onError,
        enabled: false
      }
  );
};
